export default __webpack_public_path__ + "static/media/id-jt.ce8e8f39.svg";